import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, FileText, Mountain, Crown, Layers, Plus } from 'lucide-react';
export function ComparePage() {
  const [showEdge, setShowEdge] = useState(false);
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans pb-24" data-id="element-629" data-mp="dhwa376ktw4s">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-16 px-6 md:px-12 max-w-5xl mx-auto text-center" data-id="element-630" data-mp="3htqhvplvdd31">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-631" data-mp="3cv6sff82hj5x" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-632" data-mp="3qvhiig1jytq1">
          <div className="inline-block px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-slate-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-633" data-mp="115e6xh4p7kem">
            Your Partnership Options
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight" data-id="element-634" data-mp="38tir592ktany">
            <button type="button" onClick={() => setShowEdge(isVisible => !isVisible)} aria-pressed={showEdge} aria-label={`${showEdge ? 'Show two' : 'Show three'} ways to partner`} className="inline-flex items-center rounded-lg text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7FE0C3] focus-visible:ring-offset-4 focus-visible:ring-offset-[#0A0F1C]" data-id="element-635" data-mp="3dtenqn8y1zth">
              {showEdge ? 'Three' : 'Two'}
            </button>{' '}
            Ways to Partner
          </h1>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed" data-id="element-636" data-mp="2zvghy68ovbpl">
            A simple side-by-side of everything we discussed, so you can review
            the investment and share it with your team. Every package runs the
            HIRE recruiting system at a different level of ownership and
            execution.
          </p>
        </motion.div>
      </section>

      {/* 2. CORE PACKAGES */}
      <section className={`px-6 md:px-12 ${showEdge ? 'max-w-7xl' : 'max-w-5xl'} mx-auto mb-8 transition-[max-width] duration-300`} data-id="element-637" data-mp="2926lnqww4tcl">
        <div className={`grid grid-cols-1 gap-6 items-stretch ${showEdge ? 'md:grid-cols-3' : 'md:grid-cols-2'}`} data-id="element-638" data-mp="244eooihe2h1j">
          {showEdge && <motion.article initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.25
        }} className="bg-slate-900/40 border border-slate-600 rounded-2xl p-8 flex flex-col relative" data-id="element-639" data-mp="1ccfiz4eg3zvp">
              <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-640" data-mp="31qvk1i6kakkn">
                <div className="p-2 bg-slate-800 border border-slate-700 rounded-lg" data-id="element-641" data-mp="31syh2m64tdyv">
                  <Layers className="w-6 h-6 text-slate-300" data-id="element-642" data-mp="2wr96t8qqh4bu" />
                </div>
                <h2 className="text-2xl font-bold text-white" data-id="element-643" data-mp="ij882li990bi">Edge</h2>
              </div>
              <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-644" data-mp="nk5mqo423c89">
                A managed recruiting infrastructure layer for teams that keep
                hiring, onboarding, and training in-house.
              </p>

              <div className="mb-6" data-id="element-645" data-mp="eioa5fpuxsob">
                <div className="flex items-end justify-between mb-5" data-id="element-646" data-mp="1288x09p4ta2v">
                  <span className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-647" data-mp="12a3flhcxkq3s">
                    Build (One-Time)
                  </span>
                  <span className="text-2xl font-bold text-white" data-id="element-648" data-mp="siz1skyzrbaj">$4,000</span>
                </div>
                <div className="flex items-end justify-between" data-id="element-649" data-mp="xgh1dkr4ce5v">
                  <span className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-650" data-mp="1l6uwjk502t4o">
                    Total Monthly
                  </span>
                  <span className="text-2xl font-bold text-white" data-id="element-651" data-mp="1pymnhvs2j0vc">$3,000</span>
                </div>
                <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-652" data-mp="1ctk5tzblci5">
                  <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-653" data-mp="3sha1ug8pit7i">
                    What makes up the monthly
                  </div>
                  <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-654" data-mp="3jhmyvq0bxfcc">
                    <li className="flex justify-between" data-id="element-655" data-mp="k28gjb429dg7">
                      <span data-id="element-656" data-mp="k1qcvtf2jwy9">Catalyst ATS</span>
                      <span data-id="element-657" data-mp="g0wo6xtsye4b">$1,500</span>
                    </li>
                    <li className="flex justify-between" data-id="element-658" data-mp="g1g4yb7puwgr">
                      <span data-id="element-659" data-mp="b94uiefcns9y">Campaign management</span>
                      <span data-id="element-660" data-mp="b7lemoxlvj8p">$1,500</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-661" data-mp="13qqzvc2dxwmz">
                <div className="flex items-baseline justify-between gap-3" data-id="element-662" data-mp="13s24fe3nn8f5">
                  <span className="text-xs font-bold uppercase tracking-widest text-slate-400" data-id="element-663" data-mp="yy7maf3p71i6">
                    Sales School Tickets
                  </span>
                  <span className="text-2xl font-bold text-white whitespace-nowrap" data-id="element-664" data-mp="1b8ymw4ofdmf0">
                    $200
                  </span>
                </div>
                <p className="mt-1 text-right text-sm text-slate-400" data-id="element-665" data-mp="1gb7hf5gy4wj8">per ticket</p>
                <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-666" data-mp="1kbreya5fm25w">
                  Purchased separately, up to a $5,000 monthly maximum.
                </p>
              </div>

              <div className="flex-1" data-id="element-667" data-mp="1u71hr03nmdkq">
                <div className="text-sm font-bold text-white mb-3" data-id="element-668" data-mp="1yzcdrrv9xf80">What you get:</div>
                <ul className="space-y-2.5" data-id="element-669" data-mp="1z1ovq5117pl2">
                  {['Custom ATS, application flow, and campaign creative', 'Active job board management and optimization', 'Applicant screening and pre-qualification', 'Candidate handoff to your internal team', 'Multi-market coordination and reporting'].map(item => <li key={item} className="flex items-start text-sm text-slate-300" data-id="element-670" data-mp="8w24n0mv441i">
                      <Check className="w-4 h-4 text-slate-400 mr-2 mt-0.5 shrink-0" data-id="element-671" data-mp="mn78yg16dki6" />
                      <span data-id="element-672" data-mp="hw7c1as232fo">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-673" data-mp="wk25itdw1att">
                <p className="text-sm text-slate-400 leading-relaxed" data-id="element-674" data-mp="rm0nmbs77hjx">
                  <span className="text-white font-medium" data-id="element-675" data-mp="rnuysydo3vat">Best for:</span> teams
                  with strong internal hiring and onboarding who want more
                  predictable candidate flow.
                </p>
              </div>
            </motion.article>}

          {/* ADVANTAGE */}
          <div className="bg-slate-900/60 border border-[#7FE0C3]/40 rounded-2xl p-8 flex flex-col relative" data-id="element-676" data-mp="37epu278kxoic">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 px-4 py-1 bg-[#7FE0C3] text-[#163A5F] text-xs font-bold uppercase tracking-widest rounded-full" data-id="element-677" data-mp="1hvr9cz18bz86">
              Flagship Partnership
            </div>
            <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-678" data-mp="192ea7fcko1dn">
              <div className="p-2 bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 rounded-lg" data-id="element-679" data-mp="1d4st1zg8r14x">
                <FileText className="w-6 h-6 text-[#7FE0C3]" data-id="element-680" data-mp="z59kj5jipns3" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-681" data-mp="z7clulq4f3c4">Advantage</h2>
            </div>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-682" data-mp="145nrsldaotp2">
              We build and own the recruiting system, and your team runs the
              interviews. A predictable hiring engine with full accountability.
            </p>

            {/* Pricing */}
            <div className="mb-6" data-id="element-683" data-mp="2kjxk1qknr2l6">
              <div className="flex items-end justify-between mb-5" data-id="element-684" data-mp="2kgrts80alunv">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-685" data-mp="2ojo5derf0qib">
                  Build (One-Time)
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-686" data-mp="17brj2lbiysj0">$6,500</span>
              </div>
              <div className="flex items-end justify-between" data-id="element-687" data-mp="17e41t0p3x6x4">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-688" data-mp="12jglvq865ku5">
                  Total Monthly
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-689" data-mp="tkczac9smnaw">$5,000</span>
              </div>
              <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-690" data-mp="ol9tuqpwif2e">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-691" data-mp="jm7042fdfv9q">
                  What makes up the monthly
                </div>
                <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-692" data-mp="eonak6d83w2h">
                  <li className="flex justify-between" data-id="element-693" data-mp="2dz598ipc4lvh">
                    <span data-id="element-694" data-mp="2913oltc9gehw">System fee</span>
                    <span data-id="element-695" data-mp="2926fw2dhwiyc">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-696" data-mp="2hi43a8o5sht0">
                    <span data-id="element-697" data-mp="2hhm536hxrtig">Campaign management</span>
                    <span data-id="element-698" data-mp="2ljh4g5gb3wtl">$2,500</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-699" data-mp="2qa60zz6ufjzl">
              <div className="flex items-baseline justify-between gap-3" data-id="element-700" data-mp="2v9isix8ntf8i">
                <span className="text-xs font-bold uppercase tracking-widest text-[#7FE0C3]" data-id="element-701" data-mp="2vbmvncyqia7q">
                  Sales School Tickets
                </span>
                <span className="text-2xl font-bold text-white whitespace-nowrap" data-id="element-702" data-mp="22lwhx510lac5">
                  $150
                </span>
              </div>
              <p className="mt-1 text-right text-sm text-slate-400" data-id="element-703" data-mp="27maqqpafwob8">per ticket</p>
              <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-704" data-mp="2ckcazdjlqtoa">
                Purchased separately, up to a $5,000 monthly maximum.
              </p>
            </div>

            {/* Value */}
            <div className="flex-1" data-id="element-705" data-mp="3o0anxshwhzus">
              <div className="text-sm font-bold text-white mb-3" data-id="element-706" data-mp="38ns4d7fc9ab2">
                What you get:
              </div>
              <ul className="space-y-2.5" data-id="element-707" data-mp="3dljupx0c4od5">
                {['Custom ATS, landing pages, and full funnel build', 'Active ad management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Interview auditing and coaching to improve retention', 'Monthly recruiting review and ongoing consulting'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-708" data-mp="2upbx9fdkdhse" data-mpi={i}>
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-709" data-mp="33offkh4wpt5u" />
                    <span data-id="element-710" data-mp="dzd8f3ukc836">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-711" data-mp="iwwwevh2bz8b">
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-712" data-mp="t1lp5gqo0lnb">
                <span className="text-white font-medium" data-id="element-713" data-mp="t3zh3gq1thqn">Best for:</span> teams
                that want recruiting to finally be consistent and predictable,
                while keeping interviews and final decisions in-house.
              </p>
            </div>
          </div>

          {/* SUMMIT */}
          <div className="bg-slate-900/40 border border-amber-500/30 rounded-2xl p-8 flex flex-col relative" data-id="element-714" data-mp="f8dwdlqulk41">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 px-4 py-1 bg-amber-500 text-slate-950 text-xs font-bold uppercase tracking-widest rounded-full" data-id="element-715" data-mp="a9124fxndarf">
              Full Execution
            </div>
            <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-716" data-mp="3shs2p5cmcj97">
              <div className="p-2 bg-amber-500/10 border border-amber-500/20 rounded-lg" data-id="element-717" data-mp="1ur8n9e3qry85">
                <Mountain className="w-6 h-6 text-amber-400" data-id="element-718" data-mp="1uow8tax705zu" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-719" data-mp="1qqexef6qo9cm">Summit</h2>
            </div>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-720" data-mp="3k6t57cyincac">
              Everything in Advantage, plus a dedicated US-based recruiter who
              runs your interviews. Recruiting execution handled entirely for
              you.
            </p>

            {/* Pricing */}
            <div className="mb-6" data-id="element-721" data-mp="3fa2lmfni5yk6">
              <div className="flex items-end justify-between mb-5" data-id="element-722" data-mp="3f6wxp3qm12q1">
                <span className="text-xs text-amber-400 uppercase tracking-wider" data-id="element-723" data-mp="6tzf4d84mfxf">
                  Build (One-Time)
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-724" data-mp="3ty5vi04o1ue9">$6,500</span>
              </div>
              <div className="flex items-end justify-between" data-id="element-725" data-mp="2runfk18ntdf">
                <span className="text-xs text-amber-400 uppercase tracking-wider" data-id="element-726" data-mp="2qbao3esk0ge">
                  Total Monthly
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-727" data-mp="2ni3in9by1vi1">$7,500</span>
              </div>
              <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-728" data-mp="2f12wk8xpupww">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-729" data-mp="2azhn6xke4trg">
                  What makes up the monthly
                </div>
                <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-730" data-mp="2oyqwdda6inlx">
                  <li className="flex justify-between" data-id="element-731" data-mp="2k17e82ad1qop">
                    <span data-id="element-732" data-mp="1walagn7e2ski">System fee</span>
                    <span data-id="element-733" data-mp="1wbd5nwx2qoa9">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-734" data-mp="1rbs4rgycg5uw">
                    <span data-id="element-735" data-mp="1rdbmlbzneoys">Campaign management</span>
                    <span data-id="element-736" data-mp="260wqh84cks7r">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-737" data-mp="262hkmwmr2953">
                    <span data-id="element-738" data-mp="218n1pveyxy72">Corporate recruiter</span>
                    <span data-id="element-739" data-mp="217v5cidjrwfq">$2,500</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-740" data-mp="18ladlgt5tibn">
              <div className="flex items-baseline justify-between gap-3" data-id="element-741" data-mp="18iwmfj1loq9d">
                <span className="text-xs font-bold uppercase tracking-widest text-amber-400" data-id="element-742" data-mp="bv6xqf8iufp7">
                  Sales School Tickets
                </span>
                <span className="text-2xl font-bold text-white whitespace-nowrap" data-id="element-743" data-mp="ktscs0esbcl8">
                  $125
                </span>
              </div>
              <p className="mt-1 text-right text-sm text-slate-400" data-id="element-744" data-mp="pmlk8w1n0z10">per ticket</p>
              <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-745" data-mp="ujbvn62hz6g3">
                Purchased separately, up to a $5,000 monthly maximum.
              </p>
            </div>

            {/* Value */}
            <div className="flex-1" data-id="element-746" data-mp="14jm7oncsq7to">
              <div className="text-sm font-bold text-white mb-3" data-id="element-747" data-mp="14ggi770993xf">
                Everything in Advantage, plus:
              </div>
              <ul className="space-y-2.5" data-id="element-748" data-mp="36afw804rhzdt">
                {['A dedicated US-based corporate recruiter representing your brand', 'Second-round interview execution handled for you', 'Candidate scheduling and follow-up', 'Full execution accountability'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-749" data-mp="2xz77yhxsih87" data-mpi={i}>
                    <Check className="w-4 h-4 text-amber-400 mr-2 mt-0.5 shrink-0" data-id="element-750" data-mp="2p1db95w45lki" />
                    <span data-id="element-751" data-mp="3lr4djrancd0v">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-752" data-mp="3gskupzrcnhcq">
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-753" data-mp="3cpo71umycv1x">
                <span className="text-white font-medium" data-id="element-754" data-mp="3cs0w0rr4o5oh">Best for:</span> teams
                whose leaders are too busy selling to interview, and want
                recruiting execution fully off their plate.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. SHARED NOTE */}
      <section className="px-6 md:px-12 max-w-5xl mx-auto mb-20" data-id="element-755" data-mp="1xstvwqdnygaj">
        <div className="p-5 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg" data-id="element-756" data-mp="1xtmu32yk3xh2">
          <p className="text-[#7FE0C3] text-center text-sm font-medium" data-id="element-757" data-mp="22remrz70znmb">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 4. LEADERSHIP ADD-ON */}
      <section className="px-6 md:px-12 max-w-5xl mx-auto mb-24" data-id="element-758" data-mp="1f2ly8nsqgi1q">
        <div className="text-center mb-8" data-id="element-759" data-mp="1f099nrsgz9fp">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-4" data-id="element-760" data-mp="1jtc40252mmwy">
            Optional Add-On
          </div>
          <h2 className="text-3xl font-bold text-white mb-3" data-id="element-761" data-mp="1a40uwfi6pi92">
            Add Leadership to Either Package
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto leading-relaxed" data-id="element-762" data-mp="w5ksv1v9ofx9">
            Leadership is an optional add-on that layers onto Advantage or
            Summit. Run it in tandem with your main campaign, or ahead of it to
            put the right manager in place before you scale the team beneath
            them.
          </p>
        </div>

        {/* Visual: Advantage or Summit + Leadership */}
        <div className="flex flex-col sm:flex-row items-stretch justify-center gap-4 mb-10" data-id="element-763" data-mp="qf4inlva3kza">
          <div className="flex-1 max-w-xs mx-auto sm:mx-0 bg-slate-900/40 border border-slate-700 rounded-xl p-5 text-center" data-id="element-764" data-mp="mhyq7x6ud2nr">
            <div className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-765" data-mp="vgtswzaofumb">
              Core Package
            </div>
            <div className="text-white font-bold" data-id="element-766" data-mp="1a4eyczv0y5xe">Advantage or Summit</div>
            <div className="text-xs text-slate-500 mt-1" data-id="element-767" data-mp="155tw6uw7pc6b">
              Recruits and ramps your reps
            </div>
          </div>
          <div className="flex items-center justify-center text-slate-500" data-id="element-768" data-mp="1j6wldgii72lg">
            <Plus className="w-6 h-6" data-id="element-769" data-mp="1e7tfjtup8scf" />
          </div>
          <div className="flex-1 max-w-xs mx-auto sm:mx-0 bg-slate-900/40 border border-[#7FE0C3]/30 rounded-xl p-5 text-center" data-id="element-770" data-mp="1e5777rzzi8t5">
            <div className="text-xs text-[#7FE0C3] uppercase tracking-wider mb-1" data-id="element-771" data-mp="2qi2hzmwdr6av">
              Add-On
            </div>
            <div className="text-white font-bold flex items-center justify-center" data-id="element-772" data-mp="2ul8nutfkyvgt">
              <Crown className="w-4 h-4 text-[#7FE0C3] mr-2" data-id="element-773" data-mp="2zjii91thds1d" />
              Leadership
            </div>
            <div className="text-xs text-slate-500 mt-1" data-id="element-774" data-mp="22tsri7o81ude">
              Recruits the managers who lead them
            </div>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-8" data-id="element-775" data-mp="26s8jyr32nuy7">
          <div className="flex flex-col md:flex-row gap-10" data-id="element-776" data-mp="2bsd36ovd73s4">
            <div className="flex-1" data-id="element-777" data-mp="2glfz33nm6pbh">
              <div className="text-sm font-bold text-white mb-3" data-id="element-778" data-mp="2glpho66bxu75">
                What you get:
              </div>
              <ul className="space-y-2.5" data-id="element-779" data-mp="1j3633lg9i64r">
                {['Targeted outreach to experienced operators and team leaders', 'Interviews handled for you', 'Vetted candidates passed to you for final approval only', 'Performance aligned to the leader and their team output'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-780" data-mp="16ohkxeolv1q5" data-mpi={i}>
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-781" data-mp="xm8cqvgt7kfx" />
                    <span data-id="element-782" data-mp="sv9sxlwm447x">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="w-full md:w-72 shrink-0 space-y-4 md:border-l md:border-slate-800 md:pl-10" data-id="element-783" data-mp="nvdnrjc6i6qs">
              <div className="flex items-end justify-between" data-id="element-784" data-mp="ixllpwhtl48v">
                <span className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-785" data-mp="iuzg42ehoyta">
                  Build (One-Time)
                </span>
                <span className="text-xl font-bold text-white" data-id="element-786" data-mp="9x6xao9k7915">$1,000*</span>
              </div>
              <p className="text-xs text-slate-500 -mt-2" data-id="element-787" data-mp="2uyd280dbyfau">
                *Must be built in conjunction with a standard campaign.
              </p>
              <div className="flex items-end justify-between pt-2 border-t border-slate-800/50" data-id="element-788" data-mp="2quduo7a12qtm">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-789" data-mp="2lzhxyttujfa6">
                  Monthly Management
                </span>
                <span className="text-xl font-bold text-white" data-id="element-790" data-mp="2bzhcb18i8n2t">$2,500</span>
              </div>
              <div className="flex items-end justify-between pt-2 border-t border-slate-800/50" data-id="element-791" data-mp="277za69uqwgg9">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-792" data-mp="236e3554w6wdz">
                  Performance
                </span>
                <span className="text-xl font-bold text-white" data-id="element-793" data-mp="1y9dvipse9lkr">2.5%</span>
              </div>
              <p className="text-xs text-slate-500 -mt-2" data-id="element-794" data-mp="1t7etpkcaywpx">
                Of revenue, capped at $15,000. Based on the leader's personal
                and team production combined.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. HOW TO CHOOSE */}
      <section className="px-6 md:px-12 max-w-3xl mx-auto" data-id="element-795" data-mp="1j3hvs7oh4405">
        <div className="text-center mb-10" data-id="element-796" data-mp="1o45kunt56arq">
          <h2 className="text-3xl font-bold text-white mb-3" data-id="element-797" data-mp="1o5759iw1s9m4">How to choose</h2>
          <p className="text-slate-400" data-id="element-798" data-mp="1t38oc3th48xl">
            A quick way to land on the right fit for where your team is today.
          </p>
        </div>

        <div className="space-y-4" data-id="element-799" data-mp="vd43qh5w255k">
          <div className="flex items-start bg-slate-900/30 border border-[#7FE0C3]/20 rounded-xl p-5" data-id="element-800" data-mp="10ds2xq49tsav">
            <FileText className="w-5 h-5 text-[#7FE0C3] mr-4 mt-0.5 shrink-0" data-id="element-801" data-mp="15d4ng47o6naa" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-802" data-mp="1a3ut7ik0cs5i">
              <span className="text-white font-medium" data-id="element-803" data-mp="1a67jqk3u0au6">Choose Advantage</span>{' '}
              if your team can run interviews well and you mainly need a
              recruiting system that produces consistent, qualified candidates.
            </p>
          </div>
          <div className="flex items-start bg-slate-900/30 border border-amber-500/20 rounded-xl p-5" data-id="element-804" data-mp="9m2rg8ozjeij">
            <Mountain className="w-5 h-5 text-amber-400 mr-4 mt-0.5 shrink-0" data-id="element-805" data-mp="4n9kkz47elrc" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-806" data-mp="jd74h2v3opaq">
              <span className="text-white font-medium" data-id="element-807" data-mp="edugufwene73">Choose Summit</span> if
              interviewing is eating your leadership's time and you want a
              recruiter to handle execution end to end.
            </p>
          </div>
          <div className="flex items-start bg-slate-900/30 border border-[#7FE0C3]/20 rounded-xl p-5" data-id="element-808" data-mp="3hvmh0hkp34gd">
            <Crown className="w-5 h-5 text-[#7FE0C3] mr-4 mt-0.5 shrink-0" data-id="element-809" data-mp="nhcsommwjn1" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-810" data-mp="3rs7kuzkza9im">
              <span className="text-white font-medium" data-id="element-811" data-mp="3rv3i0lp04u60">Add Leadership</span> to
              either package when you also need to recruit the managers and team
              leaders who will scale your operation.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-812" data-mp="1el9cx1fizbym">
          <p className="text-slate-500 text-sm max-w-xl mx-auto leading-relaxed" data-id="element-813" data-mp="1eodl09w42ruk">
            Most partners start with Advantage as the foundation, then add
            Summit for execution or Leadership for management hiring as their
            needs grow.
          </p>
        </div>
      </section>
    </div>;
}